<tec-info-group>
    @if (label){
    <b>{{ label }}</b>
    }
    <span><app-uuid-display [uuid]="uuid" /></span>
</tec-info-group>
